import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            emails: {
              tab_name: 'TAB_NAME',
              language: 'LANGUAGE',
              emails_list: 'EMAILS_LIST',
              email_settings: 'EMAIL_SETTINGS',
              subject: 'SUBJECT',
              body: 'BODY',
              enable_sending_email: 'ENABLE_SENDING_EMAIL',
              email_cannot_be_disabled: 'EMAIL_CANNOT_BE_DISABLED',
              variables: 'VARIABLES',
            },
          },
        },
      },
    },
  }));
}
